import React from 'react';

type AiMagicProps = {
  useGradient?: boolean;
  large?: boolean;
  small?: boolean;
};

export default function AiMagic({ useGradient = true, large = false, small = false }: AiMagicProps) {
  return (
    <svg
      width={large ? '28' : small ? '13' : '23'}
      height={large ? '25' : small ? '12' : '21'}
      viewBox="0 0 23 21"
      fill={useGradient ? 'none' : '#636363'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3743 0.402344L12.575 8.51254L20.7485 10.6962L12.575 12.8799L10.3743 20.99L8.17356 12.8799L0 10.6962L8.17356 8.51254L10.3743 0.402344Z"
        fill={useGradient ? 'url(#paint0_linear_309_12658)' : undefined}
      />
      <path
        d="M18.3355 0L19.325 3.64325L22.9999 4.62419L19.325 5.60513L18.3355 9.24838L17.3461 5.60513L13.6711 4.62419L17.3461 3.64325L18.3355 0Z"
        fill={useGradient ? 'url(#paint1_linear_309_12658)' : undefined}
      />
      <path
        d="M3.65904 15.2803L4.2476 17.4345L6.43355 18.0146L4.2476 18.5946L3.65904 20.7489L3.07047 18.5946L0.884521 18.0146L3.07047 17.4345L3.65904 15.2803Z"
        fill={useGradient ? 'url(#paint2_linear_309_12658)' : undefined}
      />
      <defs>
        {useGradient && (
          <>
            <linearGradient id="paint0_linear_309_12658" x1="18.6247" y1="20.5631" x2="-0.333714" y2="0.823286" gradientUnits="userSpaceOnUse">
              <stop stopColor="#065B74" />
              <stop offset="1" stopColor="#0B99C2" />
            </linearGradient>
            <linearGradient id="paint1_linear_309_12658" x1="22.045" y1="9.05661" x2="13.5289" y2="0.181642" gradientUnits="userSpaceOnUse">
              <stop stopColor="#065B74" />
              <stop offset="1" stopColor="#0B99C2" />
            </linearGradient>
            <linearGradient id="paint2_linear_309_12658" x1="5.86554" y1="20.6355" x2="0.83122" y2="15.3578" gradientUnits="userSpaceOnUse">
              <stop stopColor="#065B74" />
              <stop offset="1" stopColor="#0B99C2" />
            </linearGradient>
          </>
        )}
      </defs>
    </svg>
  );
}
